import styled from 'styled-components'

import { Collapse } from 'src/Components/Collapse'

export const Container = styled.div`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 0 32px 0 rgba(51, 51, 51, 0.08);

  @media (max-width: 767px) {
    min-width: unset;
    max-width: unset;
    width: 374px;

    &:has(.ant-collapse-item-active) {
      width: 100%;
      border: 1px solid transparent;
      box-shadow: none;
      border-radius: 0;
    }
  }
`

export const StyledCollapse = styled(Collapse)`
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px !important;
    outline: none;
  }

  .ant-collapse-expand-icon {
    width: 16px;
    height: 16px;
    padding-inline-start: 0 !important;
    flex-shrink: 0;
  }

  .ant-collapse-content-box {
    padding: 0 24px 24px !important;
  }

  @media (max-width: 767px) {
    &.ant-collapse
      > .ant-collapse-item.ant-collapse-item-active
      .ant-collapse-content-box {
      padding: 0 0 24px !important;
    }
  }
`

export const Title = styled.span`
  font-family: 'Segoe UI';
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`
